/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_Explore_Deals_DetailInputs */

const en_common_header_explore_deals_detail = /** @type {(inputs: Common_Header_Explore_Deals_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Founder-posted codes`)
};

const zh_common_header_explore_deals_detail = /** @type {(inputs: Common_Header_Explore_Deals_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创始人发布的优惠码`)
};

/**
* | output |
* | --- |
* | "Founder-posted codes" |
*
* @param {Common_Header_Explore_Deals_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_explore_deals_detail = /** @type {((inputs?: Common_Header_Explore_Deals_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_Explore_Deals_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_explore_deals_detail(inputs)
	return zh_common_header_explore_deals_detail(inputs)
});
export { common_header_explore_deals_detail as "common.header.explore.deals.detail" }